import React from "react";

import {
  Paper,
  Typography,
  Box,
  Avatar,
  IconButton,
  Chip,
  Tooltip,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

export default function ZoneCard({
  zone,
  states,
  onAssign,
  onRemove,
  onEdit,
  onDelete,
}) {
  const zoneStates = states?.filter((item) => item?.zoneId === zone?.id);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 4,
        overflow: "hidden",
        border: "1px solid #ECECEC",
        transition: ".3s",
        height: 300,
        display: "flex",
        flexDirection: "column",

        "&:hover": {
          boxShadow: "0 10px 30px rgba(0,0,0,.08)",
        },
      }}
    >
      {/* Header */}

      <Box
        sx={{
          background: zone?.color,
          color: "#fff",
          px: 2,
          py: 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            fontWeight={600}
            fontSize={16}
            color="#2b2b2b"
            sx={{
              lineHeight: 1.2,
            }}
          >
            {zone.name}
          </Typography>

          <Typography
            fontSize={12}
            color="#2b2b2b"
            sx={{
              lineHeight: 1.2,
            }}
          >
            ({zoneStates.length})
          </Typography>
        </Box>

        <Box>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={() => onEdit(zone)}
              sx={{
                color: "#fff",
              }}
            >
              <EditIcon
                fontSize="small"
                sx={{
                  color: "#2b2b2b",
                  "& path": {
                    fill: "#2b2b2b !important",
                  },
                }}
              />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              size="small"
              onClick={() => onDelete(zone)}
              sx={{
                color: "#fff",
              }}
            >
              <DeleteIcon
                fontSize="small"
                sx={{
                  color: "#2b2b2b",
                  "& path": {
                    fill: "#2b2b2b !important",
                  },
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* Drop Area */}

      <Box
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();

          const stateId = Number(e.dataTransfer.getData("stateId"));

          onAssign(stateId, zone.id);
        }}
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          background: "#FAFAFA",
          p: 2,
          transition: ".3s",

          "&:hover": {
            background: "#F3F8FF",
          },

          "&::-webkit-scrollbar": { width: 6 },
          "&::-webkit-scrollbar-thumb": {
            background: "#d0d0d0",
            borderRadius: 3,
          },
        }}
      >
        {zoneStates.length === 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              height: "100%",
              border: "2px dashed #D9D9D9",
              borderRadius: 3,
            }}
          >
            <Typography color="text.secondary">Drag State Here</Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {zoneStates?.map((state) => (
              <Paper
                key={state.id}
                elevation={0}
                sx={{
                  borderRadius: 2,
                  px: 1.5,
                  py: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #f2f2f2",
                  flexShrink: 0,
                }}
              >
                {/* <Avatar
                    sx={{
                      bgcolor: zone?.color,
                      width: 32,
                      height: 32,
                    }}
                  >
                    {state?.name?.charAt(0)}
                  </Avatar> */}
                <Typography fontWeight={500}>{state.name}</Typography>
                {/* <Chip
                  size="small"
                  label={zone?.name}
                  sx={{
                    mr: 1,
                    background: zone?.color,
                    color: "#fff",
                  }}
                /> */}

                <Tooltip title="Remove">
                  <IconButton
                    size="small"
                    onClick={() => onRemove(state?.id)}
                    sx={{
                      color: "#000",
                      "&:hover": {
                        color: "#d32f2f",
                        backgroundColor: "rgba(211, 47, 47, 0.08)",
                      },
                    }}
                  >
                    <CloseIcon
                      fontSize="small"
                      sx={{
                        color: "#2b2b2b",
                        "& path": {
                          fill: "#2b2b2b !important",
                        },
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Paper>
            ))}
          </Box>
        )}
      </Box>
    </Paper>
  );
}
